<template>
    <div :class="summaryCardMergedClasses">
        <div class="flex flex-row gap-2 items-center">
            <UnitBadge :units="[props.unit]" />
            <div class="flex flex-col">
                <div class="text-default">{{ unitLabel }}</div>
                <div class="text-sub text-sm">{{ typeLabel }}</div>
            </div>
        </div>
        <div class="flex flex-row justify-between items-center h-6 gap-3">
            <div class="text-lg font-semibold">{{ label }}</div>
            <Badge v-if="badgeLabel" :variant="badgeVariant" :label="badgeLabel" :suffix="badgeSuffix" :prefix="badgePrefix" size="lg" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue'
    import { UnitBadge, Badge } from '../index.js'
    import { twMerge } from 'tailwind-merge'

    const props = withDefaults(
        defineProps<{
            class?: string
            badgeLabel?: string
            badgeSuffix?: string
            badgePrefix?: string
            disabled?: boolean
            label?: string
            state?: 'success' | 'warning' | 'error'
            type?: 'violation' | 'status'
            unit?: 'temperature' | 'humidity' | 'shock' | 'battery' | 'label'
        }>(),
        {
            disabled: false,
            state: 'success',
            type: 'violation',
            unit: 'temperature'
        }
    )

    const badgeVariant = computed(() => {
        const stateOptions = {
            error: 'alert',
            warning: 'warning',
            success: 'success'
        } as const
        return stateOptions[props.state]
    })

    const unitLabel = computed(() => {
        const unitOptions = {
            temperature: 'Temperature',
            humidity: 'Humidity',
            shock: 'Shock',
            battery: 'Battery',
            label: 'Label'
        } as const
        return unitOptions[props.unit]
    })

    const typeLabel = computed(() => {
        const typeOptions = {
            violation: 'Violations',
            status: 'Status'
        } as const
        return typeOptions[props.type]
    })

    const label = computed(() => {
        if (props.label) return props.label
        if (props.disabled) return 'N.a.'
        return ''
    })

    // Allow overriding base classes
    const summaryCardBaseClasses = computed(() => {
        const baseClasses = ['bg-system-light rounded-2xl p-4 shadow-sm inline-flex min-w-52 flex-col gap-4 transition-all duration-500']
        if (props.disabled) baseClasses.push('opacity-20')
        return baseClasses
    })
    const summaryCardMergedClasses = computed(() => twMerge(summaryCardBaseClasses.value, props.class))
</script>
